import type { ComponentType, PropsWithChildren } from 'react';
import {
	Circle as RNCircle,
	type CircleProps,
	ClipPath as RNClipPath,
	type ClipPathProps,
	Defs as RNDefs,
	Ellipse as RNEllipse,
	type EllipseProps,
	G as RNG,
	type GProps,
	LinearGradient as RNLinearGradient,
	type LinearGradientProps,
	Path as RNPath,
	type PathProps,
	Rect as RNRect,
	type RectProps,
	Stop as RNStop,
	type StopProps,
	Svg as RNSvg,
	type SvgProps,
} from 'react-native-svg';

// Cast through ComponentType so this package's JSX types don't nominally pin apps to one @types/react major (18 vs 19).
export const Circle = RNCircle as unknown as ComponentType<CircleProps>;
export const ClipPath = RNClipPath as unknown as ComponentType<ClipPathProps>;
export const Defs = RNDefs as unknown as ComponentType<PropsWithChildren>;
export const Ellipse = RNEllipse as unknown as ComponentType<EllipseProps>;
export const G = RNG as unknown as ComponentType<GProps>;
export const LinearGradient = RNLinearGradient as unknown as ComponentType<LinearGradientProps>;
export const Path = RNPath as unknown as ComponentType<PathProps>;
export const Rect = RNRect as unknown as ComponentType<RectProps>;
export const Stop = RNStop as unknown as ComponentType<StopProps>;
export const Svg = RNSvg as unknown as ComponentType<SvgProps>;

export type {
	CircleProps,
	ClipPathProps,
	EllipseProps,
	GProps,
	LinearGradientProps,
	PathProps,
	RectProps,
	StopProps,
	SvgProps,
} from 'react-native-svg';
